import { render, staticRenderFns } from "./FilterTermRepeat.vue?vue&type=template&id=485f461a&scoped=true&"
import script from "./FilterTermRepeat.vue?vue&type=script&lang=js&"
export * from "./FilterTermRepeat.vue?vue&type=script&lang=js&"
import style0 from "./FilterTermRepeat.vue?vue&type=style&index=0&id=485f461a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f461a",
  null
  
)

export default component.exports